import vue from 'vue';

const mutations = {
  DESTINATIONS_CHANGE: (state, data) => {
    vue.set(state, 'destinations', data);
  },
};

export default mutations;
